<template>
    <el-dialog
        ref="DetailDialog"
        :visible="visible"
        :modal-append-to-body="false"
        :close-on-click-modal="false"
        append-to-body
        class="modify-project-dialog ah-detail-dialog"
        top="5vh"
        @open="onOpen"
        @close="onClose"
    >
        <div class="layout">
            <div class="dialog-header">
                <div class="dialog-title">變更所屬專案</div>
            </div>
            <div class="dialog-body" style="padding: 20px 30px;">
                <el-form @submit.native.prevent label-position="top">
                    <el-form-item label="專案來源">
                        <el-radio-group v-model="variableProjectTyp" @change="onVariableProjectTypChange">
                            <el-radio :label="0">無專案</el-radio>
                            <el-radio :label="2">專案</el-radio>
                            <el-radio :label="1">特定費用項目</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="專案編號" v-if="variableProjectTyp === 2">
                        <el-select
                            v-model="poo"
                            name="project"
                            :placeholder="companyInfo && companyInfo.displayProject ? '請選擇專案' : '請輸入專案名稱關鍵字（至少兩個字）'"
                            :no-data-text="companyInfo && companyInfo.displayProject ? '無專案' : '無匹配專案'"
                            remote
                            :remote-method="projectRemoteMethod"
                            filterable
                            clearable
                            no-match-text="無匹配專案"
                            class="project-select"
                            style="width: 100%;"
                            @keydown.native.capture.enter="preventIMESelect"
                        >
                            <el-option v-for="item in projectList" :key="item.poo" :label="item.nam" :value="item.poo" />
                        </el-select>
                    </el-form-item>
                    <el-form-item label="特定費用項目" v-if="variableProjectTyp === 1">
                        <el-select
                            v-model="poo"
                            name="project"
                            placeholder="請選擇"
                            no-data-text="無項目"
                            no-match-text="無匹配項目"
                            filterable
                            clearable
                            class="project-select"
                            style="width: 100%;"
                            @keydown.native.capture.enter="preventIMESelect"
                        >
                            <el-option v-for="item in specialProjectList" :key="item.poo" :label="item.nam" :value="item.poo" />
                        </el-select>
                    </el-form-item>
                </el-form>
            </div>
            <div class="dialog-footer">
                <el-button icon="el-icon-close" @click="onClose">取消</el-button>
                <el-button v-if="!isQR()" type="primary" icon="el-icon-right" @click="submit" :loading="isSubmitting">送出</el-button>
            </div>
        </div>
    </el-dialog>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
    name: 'modify-project-dialog',
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        sno: {
            type: Number,
            default: null,
        },
        currentPoo: {
            type: String,
            default: null,
        },
        currentPaymentTyp: {
            default: null,
        },
    },
    data() {
        return {
            poo: null,
            variableProjectTyp: 2, // 0: 無 | 1: 特支專案 | 2: 專案
            isSubmitting: false,
            projectList: [],
            specialProjectList: [],
        };
    },
    computed: {
        ...mapGetters({
            companyInfo: 'menu/companyInfo',
        }),
    },
    methods: {
        onOpen() {
            const typ = String(this.currentPaymentTyp);
            if (typ === '2') {
                this.variableProjectTyp = 2;
            } else if (typ === '3') {
                this.variableProjectTyp = 1;
            } else {
                this.variableProjectTyp = 0;
            }
            this.poo = null;

            if (this.companyInfo && this.companyInfo.displayProject) {
                this.fetchProjectList().then(() => {
                    if (this.variableProjectTyp === 2 && this.currentPoo) {
                        this.poo = this.currentPoo;
                    }
                });
            } else if (this.variableProjectTyp === 2 && this.currentPoo) {
                this.fetchProjectList(this.currentPoo).then(() => {
                    this.poo = this.currentPoo;
                });
            } else {
                this.projectList = [];
            }

            this.fetchSpecialProjectList().then(() => {
                if (this.variableProjectTyp === 1 && this.currentPoo) {
                    this.poo = this.currentPoo;
                }
            });
        },
        onClose() {
            this.$emit('close');
        },
        onVariableProjectTypChange() {
            this.poo = null;
        },
        projectRemoteMethod(query) {
            const trimmedQuery = this.getTrimmedQuery(query);
            if (!trimmedQuery) return;
            this.fetchProjectList(query);
        },
        getTrimmedQuery(str) {
            return str
                .split('')
                .filter((c) => c !== ' ')
                .join('');
        },
        preventIMESelect(e) {
            if (e.keyCode === 229) e.stopPropagation();
        },
        fetchProjectList(query) {
            return this.$api({
                url: 'PaymentManagenmentPage/GetProjectOptions?Type=1',
                method: 'GET',
                params: { keyword: query },
            }).then((resp) => {
                this.projectList = resp.data.options;
            });
        },
        fetchSpecialProjectList() {
            return this.$api({
                url: '/PaymentManagenmentPage/GetProjectOptions?Type=2',
                method: 'GET',
            }).then((resp) => {
                this.specialProjectList = resp.data.options;
            });
        },
        submit() {
            if (!this.sno) return;

            if (this.variableProjectTyp !== 0 && !this.poo) {
                this.$message({
                    showClose: true,
                    message: '請選擇一個專案或特定費用項目',
                    type: 'warning',
                });
                return;
            }

            const getName = () => {
                if (this.variableProjectTyp === 0) return '無專案（一般請款）';
                const list = this.variableProjectTyp === 2 ? this.projectList : this.specialProjectList;
                const item = list.find((p) => p.poo === this.poo);
                return item ? `${item.nam}（${this.poo}）` : this.poo;
            };

            this.$confirm(`確認將所屬專案變更為「${getName()}」？`, '確認變更', {
                confirmButtonText: '確認',
                cancelButtonText: '取消',
                type: 'warning',
            }).then(() => {
                this.isSubmitting = true;
                this.$api({
                    url: '/PaymentManagenmentPage/ModifyRelatedProject',
                    method: 'POST',
                    data: {
                        sno: this.sno,
                        poo: this.variableProjectTyp === 0 ? null : this.poo,
                    },
                }).then(() => {
                    this.$message({
                        showClose: true,
                        message: '變更專案成功',
                        type: 'success',
                    });
                    this.$emit('success');
                }).catch((e) => {
                    if (e && e.data && e.data.message) {
                        this.$message({
                            showClose: true,
                            message: e.data.message,
                            type: 'error',
                        });
                    } else if (e && e.message) {
                        this.$message({
                            showClose: true,
                            message: e.message,
                            type: 'error',
                        });
                    }
                }).finally(() => {
                    this.isSubmitting = false;
                });
            }).catch(() => {});
        },
    },
};
</script>
<style lang="scss">
.modify-project-dialog.ah-detail-dialog {
    $borderRadius: 20px;
    .el-dialog {
        top: 4vh;
        background-color: #fff;
        width: calc(100% - 10px);
        border-radius: $borderRadius;

        @media (min-width: 720px) {
            max-width: 500px;
        }

        .el-dialog__header {
            display: none;
        }
        .el-dialog__body {
            padding: 0;
            height: 100%;
        }
    }

    .layout {
        >.dialog-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 30px 30px;
        }

        >.dialog-body {
            min-height: 100px;
        }
        >.dialog-footer {
            display: flex;
            justify-content: flex-end;
            padding: 20px 30px;
        }
    }

    .dialog-title {
        font-size: 14pt;
        font-weight: bold;
    }
}
</style>
